module.exports = __webpack_public_path__ + "static/media/readiness-radio-active.08d86597.svg";